import React, { FC, useEffect, useRef, useState, useContext } from "react";
import { TasksContext, TasksDispatchContext, TasksProvider, useTask } from '../stateManagement/context';
import { get, post } from "../fetchers/fetchers";
import {
    IAssessmentSettings,
    IAssessmentProject,
} from "../types/types";

import {
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow, TextField
} from "@material-ui/core";
import { useParams } from "react-router";

import { API_URL } from "../env";
import { FormattedInput } from '@h-a-r-c/react-formatted-input';
import { getAssessmentSettings, getControlMeasureCosts } from "../stateManagement/data";
import { set } from "date-fns";

interface IAssessmentSettingsProps {
    updateAssessmentSettings: (currentSettings: IAssessmentSettings) => void;

}

interface IRouteParams {
    id: string
}



const AssessmentSettingsCost: FC<IAssessmentSettingsProps> = ({ updateAssessmentSettings }) => {

    let dispatch = useContext(TasksDispatchContext)
    let tasks = useTask()


    const [write_access, setWriteAccess] = useState<boolean>(true);

    const params = useParams<IRouteParams>()


    const [assessmentSettings, setAssessmentSettings] = useState<IAssessmentSettings>();


    useEffect(() => {
        if (tasks.loaded) {
            setAssessmentSettings(tasks.assessmentSettings)
        }
    }, [tasks.loaded, tasks.assessmentSettings])

    const uploadAssessmentSettings = (assessmentSettings: IAssessmentSettings) => {
        let c = { ...assessmentSettings }

        updateAssessmentSettings(c)
    }



    return (
        <>
            <Paper variant={"outlined"} style={{ display: "flex", flexDirection: "column", height: "100%", margin: "10px", flex: 1 }}>
                <Table>
                    <TableBody>
                        <TableRow>
                            <TableCell>Discount rate period</TableCell>
                            <TableCell>
                            {assessmentSettings && <FormattedInput
                                    obj={assessmentSettings}
                                    fieldKey={"total_project_years"}
                                    format={"number"}
                                    setObj={setAssessmentSettings}
                                    updateObj={uploadAssessmentSettings}
                                    write_access={write_access}
                                />}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Discount rate</TableCell>
                            <TableCell>
                                
                            {assessmentSettings && <FormattedInput
                                    obj={assessmentSettings}
                                    fieldKey={"discount_rate"}
                                    format={"percent"}
                                    setObj={setAssessmentSettings}
                                    updateObj={uploadAssessmentSettings}
                                    write_access={write_access}
                                />}

                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Value to prevent a fatality</TableCell>
                            <TableCell>

                                {assessmentSettings && <FormattedInput
                                    obj={assessmentSettings}
                                    fieldKey={"value_of_life"}
                                    format={"dollar"}
                                    setObj={setAssessmentSettings}
                                    updateObj={uploadAssessmentSettings}
                                    write_access={write_access}
                                />}

                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>DF and CSSL assessment</TableCell>
                            <TableCell>
                            {assessmentSettings &&<Select
                                style={{fontSize:"11pt"}}
                                value={assessmentSettings?.ancold_guideline_id ?? 1}
                                disabled={!write_access}
                                onChange={ (event) => {
                                    let value = parseInt(event.target.value as string)
                                    if (value) {
                                        let c = {...assessmentSettings}
                                        c.ancold_guideline_id = value
                                        setAssessmentSettings(c)
                                        uploadAssessmentSettings(c)
                                    }
                                }}>
                                <MenuItem value={1}>ANCOLD 2003</MenuItem>
                                <MenuItem value={2}>ANCOLD 2022</MenuItem>

                            </Select>
                            }
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Paper>
        </>
    );
}

export default AssessmentSettingsCost;
